{
  "404": {
    "title": "此页面已去钓鱼",
    "text": "如果您觉得这不对，请给我们发送消息",
    "back_button": "返回仪表板"
  },
  "auth": {
    "agree": "我同意",
    "createAccount": "创建账号",
    "createNewAccount": "创建新账号",
    "email": "电子邮箱",
    "login": "登录",
    "password": "密码",
    "recover_password": "恢复密码",
    "sign_up": "注册",
    "keep_logged_in": "保持登录",
    "termsOfUse": "使用条款",
    "reset_password": "重置密码"
  },
  "typography": {
    "primary": "主要文本样式",
    "secondary": "次要文本样式"
  },
  "dashboard": {
    "versions": "版本",
    "setupRemoteConnections": "设置远程连接",
    "currentVisitors": "当前访问者",
    "charts": {
      "trendyTrends": "流行趋势",
      "showInMoreDetail": "显示更多细节",
      "showInLessDetail": "显示较少细节",
      "loadingSpeed": "加载速度",
      "topContributors": "主要贡献者",
      "showNextFive": "显示接下来的五个",
      "commits": "提交"
    },
    "info": {
      "componentRichTheme": "组件丰富的主题",
      "completedPullRequests": "已完成的拉取请求",
      "users": "用户",
      "points": "点数",
      "units": "单位",
      "exploreGallery": "探索画廊",
      "viewLibrary": "查看库",
      "commits": "提交",
      "components": "组件",
      "teamMembers": "团队成员"
    },
    "tabs": {
      "overview": {
        "title": "概述",
        "built": "使用 Vue.js 框架构建",
        "free": "对所有人完全免费",
        "fresh": "新鲜和清新的设计",
        "mobile": "响应式且优化移动",
        "components": "大量有用的组件",
        "nojQuery": "完全不使用 jQuery"
      },
      "billingAddress": {
        "title": "账单地址",
        "personalInfo": "个人信息",
        "firstName": "名字 & 姓氏",
        "email": "电子邮箱",
        "address": "地址",
        "companyInfo": "公司信息",
        "city": "城市",
        "country": "国家",
        "infiniteConnections": "无限连接",
        "addConnection": "添加连接"
      },
      "bankDetails": {
        "title": "银行详情",
        "detailsFields": "详情字段",
        "bankName": "银行名称",
        "accountName": "账户名称",
        "sortCode": "排序代码",
        "accountNumber": "账号",
        "notes": "备注",
        "sendDetails": "发送详情"
      }
    },
    "navigationLayout": "导航布局",
    "topBarButton": "顶部按钮",
    "sideBarButton": "侧边按钮"
  },
  "language": {
    "english": "英语",
    "simplified_chinese": "简体中文"
  },
  "menu": {
    "404": "404 页面",
    "auth": "授权",
    "buttons": "按钮",
    "timelines": "时间线",
    "dashboard": "仪表板",
    "billing": "计费",
    "login": "登录",
    "signUp": "注册",
    "profile": "个人资料",
    "payments": "支付",
    "pricing-plans": "定价计划",
    "login-singup": "登录/注册",
    "faq": "常见问题解答",
    "users": "用户管理",
    "projects": "项目管理",
    "roles": "角色管理",
    "permissions": "权限管理",
    "payment-methods": "支付方式",
    "management": "系统管理",
    "settings": "系统设置",
    "tickets": "工单管理"
  },
  "messages": {
    "all": "查看所有消息",
    "new": "来自 {name} 的新消息",
    "mark_as_read": "标记为已读"
  },
  "navbar": {
    "messageUs": "需要Web开发帮助吗？请联系我们。",
    "repository": "GitHub 仓库"
  },
  "notifications": {
    "all": "查看所有通知",
    "mark_as_read": "标为已读",
    "sentMessage": "{name} 给你发了一条消息",
    "uploadedZip": "{name} 上传了一个新的 Zip 文件 {type}",
    "startedTopic": "{name} 开始了一个新话题"
  },
  "user": {
    "language": "修改语言",
    "logout": "登出",
    "profile": "我的资料",
    "settings": "设置",
    "billing": "账单",
    "faq": "常见问题",
    "helpAndSupport": "帮助与支持",
    "projects": "项目",
    "account": "账户",
    "explore": "探索"
  },
  "treeView": {
    "basic": "基本型",
    "icons": "图标",
    "selectable": "可选择",
    "editable": "可编辑",
    "advanced": "高级"
  },
  "chat": {
    "title": "聊天"
  },
  "cards": {
    "cards": "卡片",
    "fixed": "固定的",
    "floating": "浮动的",
    "contentText": "独特的斑马条纹使它们成为人们最熟悉的动物之一。",
    "rowHeight": "行高",
    "title": {
      "dark": "暗色背景",
      "bright": "亮色卡片",
      "titleOnImageNoOverlay": "图像上的标题，但没有叠加",
      "normal": "标准卡",
      "overlayAndTextOnImage": "图像上有覆盖和文本的卡片",
      "stripeNoImage": "无图像条纹卡"
    },
    "button": {
      "main": "主要",
      "cancel": "取消"
    },
    "link": {
      "edit": "编辑",
      "setAsDefault": "设为默认",
      "delete": "删除",
      "traveling": "Traveling",
      "france": "法国",
      "review": "评论",
      "feedback": "反馈信息",
      "readFull": "阅读全文",
      "secondaryAction": "第二行为",
      "action1": "行为 1",
      "action2": "行为 2"
    }
  },
  "helpAndSupport": "帮助与支持",
  "aboutVuesticAdmin": "关于 Vuestic Admin",
  "search": {
    "placeholder": "搜索..."
  },
  "vuestic": {
    "search": "搜索",
    "noOptions": "未找到项目",
    "ok": "确认",
    "cancel": "取消",
    "uploadFile": "上传文件",
    "undo": "撤销",
    "dropzone": "将文件拖到此处上传",
    "fileDeleted": "文件已删除",
    "closeAlert": "关闭警告",
    "backToTop": "回到顶部",
    "toggleDropdown": "切换下拉菜单",
    "carousel": "轮播",
    "goPreviousSlide": "上一张幻灯片",
    "goNextSlide": "下一张幻灯片",
    "goSlide": "跳转到第 {index} 张幻灯片",
    "slideOf": "第 {index} 张，共 {length} 张",
    "close": "关闭",
    "select": "选择"
  },
  "settings": {
    "title": "设置",
    "theme": "主题",
    "preferences": "偏好设置",
    "notificationAlert": {
      "title": "通知提醒",
      "description": "您有未读的通知消息"
    },
    "notifications": {
      "title": "通知设置"
    },
    "openColorPicker": "打开颜色选择器",
    "colorSelection": "颜色选择",
    "colorName": "颜色 {color}",
    "decreaseCounter": "减少计数",
    "increaseCounter": "增加计数",
    "selectAllRows": "选择所有行",
    "sortColumnBy": "按 {name} 排序",
    "selectRowByIndex": "选择第 {index} 行",
    "resetDate": "重置日期",
    "nextPeriod": "下一个时间段",
    "switchView": "切换视图",
    "previousPeriod": "上一个时间段",
    "removeFile": "删除文件",
    "reset": "重置",
    "pagination": "分页",
    "goToTheFirstPage": "跳转到第一页",
    "goToPreviousPage": "跳转到上一页",
    "goToSpecificPage": "跳转到第 {page} 页",
    "goToSpecificPageInput": "输入页码以跳转",
    "goNextPage": "跳转到下一页",
    "goLastPage": "跳转到最后一页",
    "currentRating": "当前评分 {value} / {max}",
    "voteRating": "评分 {value} / {max}",
    "optionsFilter": "选项筛选",
    "splitPanels": "分割面板",
    "movePaginationLeft": "分页向左移动",
    "movePaginationRight": "分页向右移动",
    "resetTime": "重置时间",
    "closeToast": "关闭提示",
    "selectedOption": "已选选项",
    "noSelectedOption": "未选择选项",
    "breadcrumbs": "面包屑导航",
    "counterValue": "计数值",
    "selectedDate": "选择的日期",
    "selectedTime": "选择的时间",
    "progressState": "进度状态",
    "color": "颜色",
    "next": "下一步",
    "back": "上一步",
    "finish": "完成",
    "step": "步骤",
    "progress": "进度",
    "loading": "加载中",
    "sliderValue": "当前滑块值为 {value}",
    "switch": "切换",
    "inputField": "输入框",
    "fileTypeIncorrect": "文件类型不正确",
    "select": "选择一个选项"
  },
  "buttonSelect": {
    "dark": "深色",
    "light": "浅色"
  },
  "system": {
    "asset": {
      "title": "资产管理",
      "list": "资产列表",
      "add": "添加资产",
      "edit": "编辑资产",
      "delete": "删除资产",
      "detail": "资产详情",
      "import": "导入资产",
      "export": "导出资产",
      "scan": "扫描资产",
      "type": "资产类型",
      "status": "资产状态",
      "ip": "IP地址",
      "mac": "MAC地址",
      "hostname": "主机名",
      "os": "操作系统",
      "department": "所属部门",
      "owner": "责任人",
      "purchaseDate": "购买日期",
      "expiryDate": "过期日期",
      "vendor": "供应商",
      "model": "型号",
      "location": "位置",
      "risk": "风险等级",
      "description": "描述",
      "tags": "标签",
      "network": "网络信息",
      "ports": "开放端口",
      "services": "运行服务",
      "vulnerabilities": "漏洞信息",
      "maintenance": "维护记录",
      "history": "历史记录"
    },
    "user": {
      "title": "用户管理",
      "list": "用户列表",
      "add": "添加用户",
      "edit": "编辑用户",
      "delete": "删除用户",
      "detail": "用户详情",
      "username": "用户名",
      "password": "密码",
      "email": "电子邮箱",
      "phone": "手机号码",
      "role": "角色",
      "status": "状态",
      "lastLogin": "上次登录",
      "createTime": "创建时间",
      "updateTime": "更新时间",
      "department": "所属部门",
      "permissions": "权限设置",
      "active": "激活",
      "inactive": "禁用",
      "resetPassword": "重置密码",
      "currentPassword": "当前密码",
      "newPassword": "新密码",
      "confirmPassword": "确认密码"
    },
    "security": {
      "title": "安全管理",
      "totp": {
        "title": "双因素认证",
        "setup": "设置双因素认证",
        "disable": "禁用双因素认证",
        "verify": "验证",
        "scan": "扫描二维码",
        "code": "验证码",
        "backupCodes": "备份码",
        "enabled": "已启用",
        "disabled": "已禁用",
        "enableSuccess": "双因素认证启用成功",
        "disableSuccess": "双因素认证禁用成功"
      },
      "loginLog": "登录日志",
      "operationLog": "操作日志",
      "ipWhitelist": "IP白名单",
      "securityPolicy": "安全策略",
      "passwordPolicy": "密码策略",
      "auditLog": "审计日志"
    },
    "network": {
      "title": "网络管理",
      "discovery": "网络发现",
      "scan": "网络扫描",
      "monitor": "网络监控",
      "topology": "网络拓扑",
      "device": "网络设备",
      "segment": "网段管理",
      "firewall": "防火墙",
      "router": "路由器",
      "switch": "交换机",
      "server": "服务器",
      "workstation": "工作站",
      "connection": "连接管理"
    },
    "vulnerability": {
      "title": "漏洞管理",
      "list": "漏洞列表",
      "scan": "漏洞扫描",
      "report": "漏洞报告",
      "level": "漏洞等级",
      "type": "漏洞类型",
      "status": "漏洞状态",
      "description": "漏洞描述",
      "solution": "修复方案",
      "affectedAssets": "受影响资产",
      "cve": "CVE编号",
      "publish_date": "发布日期",
      "fix_date": "修复日期",
      "verified": "已验证",
      "unverified": "未验证"
    },
    "report": {
      "title": "报表中心",
      "asset": "资产报表",
      "security": "安全报表",
      "network": "网络报表",
      "vulnerability": "漏洞报表",
      "custom": "自定义报表",
      "export": "导出报表",
      "generate": "生成报表",
      "template": "报表模板",
      "schedule": "定时报表",
      "dashboard": "数据看板"
    },
    "system": {
      "title": "系统设置",
      "basic": "基本设置",
      "backup": "备份恢复",
      "log": "系统日志",
      "update": "系统更新",
      "about": "关于系统",
      "license": "许可证信息",
      "version": "版本信息",
      "storage": "存储管理",
      "task": "计划任务",
      "notification": "通知设置",
      "integration": "系统集成",
      "api": "API配置"
    },
    "common": {
      "search": "搜索",
      "add": "添加",
      "edit": "编辑",
      "delete": "删除",
      "view": "查看",
      "save": "保存",
      "cancel": "取消",
      "confirm": "确认",
      "back": "返回",
      "next": "下一步",
      "previous": "上一步",
      "submit": "提交",
      "reset": "重置",
      "refresh": "刷新",
      "import": "导入",
      "export": "导出",
      "upload": "上传",
      "download": "下载",
      "success": "成功",
      "error": "错误",
      "warning": "警告",
      "info": "提示",
      "loading": "加载中",
      "noData": "暂无数据",
      "total": "共 {total} 条记录",
      "page": "第 {page} 页",
      "itemsPerPage": "每页 {size} 条",
      "filter": "筛选",
      "sort": "排序",
      "ascending": "升序",
      "descending": "降序",
      "required": "必填",
      "optional": "选填",
      "more": "更多",
      "less": "收起",
      "all": "全部",
      "yes": "是",
      "no": "否"
    }
  },
  "agent": {
    "title": "Agent管理",
    "form": {
      "name": "名称",
      "reportUrl": "上报地址",
      "reportType": "上报类型",
      "systemInfo": "系统信息",
      "processInfo": "进程信息",
      "networkInfo": "网络信息",
      "dockerInfo": "Docker信息",
      "userInfo": "用户信息",
      "collectionInterval": "收集间隔(秒)",
      "monitoringConfig": "监控配置"
    },
    "status": {
      "online": "在线",
      "offline": "离线"
    }
  }
}
